import * as React from 'react';

import {ReduxFormSelectPickerGeneric} from 'shells/redux-form-fields/select-picker-generic/select-picker-generic';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

// @ts-expect-error
import {appHistory} from '../../../../history';

import {useGetStagesets} from '../../select/hooks/use-get-stagesets';
import {useGetSessionUser} from '../../use-get-session-user';

import {AUTO_DISTRIBUTE_OPTION} from './consts';

type Props = FieldProps & {
    includeAutoDistribute?: boolean;
};

// Redux-based pipeline select that renders as a dropdown
// (does not turn into a "card" when it has a value)
export function PipelineSelectSingle(props: Props) {
    const {includeAutoDistribute = false} = props;
    const {stagesets} = useGetStagesets();
    const {user} = useGetSessionUser();

    const stagesetOptions = stagesets.map((stageset) => {
        return {
            isDisabled: !stageset.canAccess,
            label: stageset.name,
            value: stageset.id,
        };
    });

    const options = includeAutoDistribute
        ? [AUTO_DISTRIBUTE_OPTION, ...stagesetOptions]
        : stagesetOptions;

    React.useEffect(() => {
        if (includeAutoDistribute && !props.input.value) {
            props.input.onChange(AUTO_DISTRIBUTE_OPTION.value);
        }
    }, [includeAutoDistribute, props.input]);

    let selectedValue = options.find((field) => field.value === props.input.value);
    if (!selectedValue && includeAutoDistribute) {
        selectedValue = AUTO_DISTRIBUTE_OPTION;
    }

    return (
        <ReduxFormSelectPickerGeneric
            {...props}
            onRemove={() => props.input.onChange(null)}
            options={options}
            placeholder='Select a pipeline'
            value={selectedValue}
            footerButton={
                user && user.permissions.canAccessSetup
                    ? {
                          label: 'Manage pipelines',
                          onClick: () => {
                              appHistory.push('/sales/pipelines');
                          },
                      }
                    : undefined
            }
        />
    );
}
